<div class="flex h-full w-full">
  <div class="page-left h-full w-1/2">
    <div class="tp-hero h-full pt-12">
      <div class="tp-logo-container">
        <img
          class="tp-logo-white"
          src="Traction.png"
          alt="White Traction Travel Logo"
        />
      </div>
    </div>
  </div>
  <div
    class="page-right flex h-full w-1/2 flex-col items-center justify-center"
  >
    <div class="w-1/2">
      <div class="kh-marketing-login-header">Sign In</div>
      <div class="terms pt-6 pb-4">
        By using Traction, you agree to our
        <a
          href="https://www.kimley-horn.com/?s=terms+of+use"
          class="text-gray-500 underline"
        >
          Terms and Conditions.
        </a>
      </div>
      <button class="login100-form-btn" (click)="this.authService.login()">
        Sign In<mat-icon class="signin-icon ml-2">exit_to_app</mat-icon>
      </button>
    </div>
    <div class="footer flex w-1/2 p-12">
      <div class="footer-left flex w-1/2 flex-col justify-end">
        <a
          href="https://www.kimley-horn.com/solutions/smart-cities/traction-priority "
          class="text-gray-500 underline"
        >
          Resources
        </a>
      </div>
      <div class="footer-right flex w-1/2 flex-col items-end justify-end">
        <img src="KH_footer_logo.png" alt="kh logo" class="w-[120px]" />
        <div>Copyright 2023. All Rights Reserved</div>
      </div>
    </div>
  </div>
</div>
